var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './axios';
export function saveAdverseReaction(params) {
    return __awaiter(this, void 0, void 0, function () {
        var json, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    json = JSON.stringify(params);
                    return [4 /*yield*/, axios.post("/api/adverseReaction", json)];
                case 1:
                    response = _a.sent();
                    console.log(response.data);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
export function saveTerapia(params) {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    response = {};
                    json = JSON.stringify(params);
                    return [4 /*yield*/, axios.post("/api/farmaci", json).catch(function (error) {
                            throw error;
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function filterFarmaci(param) {
    return __awaiter(this, void 0, Promise, function () {
        var json, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    json = JSON.stringify({ search: param });
                    return [4 /*yield*/, axios.post("/api/farmacifilter", json)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.data];
            }
        });
    });
}
export function filterFarmaciVaccini(param) {
    return __awaiter(this, void 0, Promise, function () {
        var json, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    json = JSON.stringify({ search: param });
                    return [4 /*yield*/, axios.post("/api/farmaciVacciniFilter", json)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.data];
            }
        });
    });
}
export function getFarmaci(idp, tipo) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("/api/getFarmaci/".concat(tipo, "/").concat(idp))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.data];
            }
        });
    });
}
export function getAdverseReaction() {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("/api/getAdverseReaction")];
                case 1:
                    response = _a.sent();
                    console.log(response.data.data);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
export function fetchSecuritySettings() {
    return __awaiter(this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("/api/fetchSecuritySettings")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error fetching security settings:', error_1);
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function deleteFarmaci(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete("/api/farmaci/".concat(id))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
export function checkFarmaco(idFarmaco) {
    return __awaiter(this, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("/api/checkFarmaco/".concat(idFarmaco))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_2 = _a.sent();
                    console.error('Errore durante il controllo del farmaco:', error_2);
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function checkInterazioniFarmaco(idFarmaco) {
    return __awaiter(this, void 0, void 0, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("/api/checkInterazioniFarmaco/".concat(idFarmaco))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_3 = _a.sent();
                    console.error('Errore durante il controllo delle interazioni:', error_3);
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
